// Pill de status reutilizável entre Painel, Vistorias.tsx e VistoriaDetalhe.tsx — mapeia por
// "família" de significado (azul=em progresso, âmbar=pendente, verde=concluído, neutro=arquivado)
// em vez de 1 cor por enum, então cobre StatusVistoria e StatusAgendamento com o mesmo componente.
export type VariantePill = "azul" | "ambar" | "verde" | "neutro";

export function Pill({ variante, children }: { variante: VariantePill; children: string }) {
  return <span className={`pill pill-${variante}`}>{children}</span>;
}

const VARIANTE_STATUS_VISTORIA: Record<string, { variante: VariantePill; rotulo: string }> = {
  EM_ANDAMENTO: { variante: "azul", rotulo: "Em andamento" },
  CONCLUIDA: { variante: "ambar", rotulo: "Gerando PDF" },
  PDF_GERADO: { variante: "verde", rotulo: "PDF pronto" },
  ENVIADA: { variante: "verde", rotulo: "Enviada" },
};

export function PillStatusVistoria({ status }: { status: string }) {
  const info = VARIANTE_STATUS_VISTORIA[status] ?? { variante: "neutro" as const, rotulo: status };
  return <Pill variante={info.variante}>{info.rotulo}</Pill>;
}

const VARIANTE_STATUS_AGENDAMENTO: Record<string, { variante: VariantePill; rotulo: string }> = {
  AGENDADO: { variante: "ambar", rotulo: "Agendado" },
  CONFIRMADO: { variante: "azul", rotulo: "Confirmado" },
  REALIZADO: { variante: "verde", rotulo: "Realizado" },
  CANCELADO: { variante: "neutro", rotulo: "Cancelado" },
};

export function PillStatusAgendamento({ status }: { status: string }) {
  const info = VARIANTE_STATUS_AGENDAMENTO[status] ?? { variante: "neutro" as const, rotulo: status };
  return <Pill variante={info.variante}>{info.rotulo}</Pill>;
}

/** "Maria Síndica" -> "MS", "Carlos" -> "CA" — pro avatar-inicial quando não há foto de usuário. */
export function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/);
  if (partes.length === 1) return partes[0]!.slice(0, 2).toUpperCase();
  return (partes[0]![0]! + partes[partes.length - 1]![0]!).toUpperCase();
}
